/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-anonymous-default-export */
import { Button, notification, Space, Table } from "antd";
import { useRef, useState, useImperativeHandle, forwardRef, useEffect } from "react";
import DataTable, { DataTableRef } from "../../common/components/DataTable";
import { ActionResult, Query } from "../../common/hooks/useApi";
import { FilterReincidenciaProps, Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import useLotesImpresionAPI from "../useLotesImpresionAPI";
import { FilePdfOutlined } from '@ant-design/icons';
import { createGlobalStyle } from "styled-components";

export interface LoteImpresionCheckProps {
  list: (query: Query) => Promise<ActionResult<Infraccion[]>>
  agenteFirmanteId?: number,
  empresaCorreoId?: number,
  query?: Query
  onGenerateLoteCloseModal?: (showModal: boolean) => any
  FilterReincidencias?: any
  infraccionesIds?: number[];
  unidadesProdNombres?: string[]
}

export interface LoteImpresionCheckRef {
  updateTable: () => Promise<void>
}

const StyleTable = createGlobalStyle`
  table
  {
    min-width:1250px!important;
  }
  .ant-table-tbody > tr > td {
  height: 4px;
  padding: 5px;
  }
  .ant-table-thead > tr > th {
  height: 4px;
  padding: 5px;
  }
  .ant-table-cell-row-hover :hover {
    background: rgba(224, 248, 232, 1);
  }
`;

export default forwardRef<LoteImpresionCheckRef, LoteImpresionCheckProps>((props, ref) => {
  const refTable = useRef<DataTableRef>(null!);

  const api = useLotesImpresionAPI();

  const [loading, setLoading] = useState(false);
  const [idInfraccionesExcluidas, setIdInfraccionesExcluidas] = useState<number[] | null>([])

  const handleSetAgenteYEmpresaCorreoLocalStorage = () => {
    /*localStorage.setItem('agentePreseleccionado', JSON.stringify(props.agenteFirmanteId))*/
    localStorage.setItem('empresaCorreoPreseleccionado', JSON.stringify(props.empresaCorreoId))
  }
  const generateLote = async () => {
    notification.info({
      message: "Generando lote...",
      duration: 0
    });

    setLoading(true);
    const response = await api.generateLote(
      props.query!,
      idInfraccionesExcluidas!,
      props.agenteFirmanteId!,
      props.empresaCorreoId!,
      props.infraccionesIds, props.unidadesProdNombres);
    setLoading(false);

    notification.destroy();

    if (!response.error) {
      handleSetAgenteYEmpresaCorreoLocalStorage();
      notification.success({
        message: "Lote generado correctamente",
        duration: 5
      });
      await refTable.current.loadItems();
    } else {
      notification.error({
        message: "Error al generar el lote de impresión"
      });
    }

    if (!Array.isArray(response.data?.value)) {
      window.location.href = response.data!.value;
    }

    notification.success({
      message: "Descargando archivos...",
      duration: 10
    });

    props.onGenerateLoteCloseModal?.(false);
  };

  const updateTable = async () => {
    await refTable.current.loadItems()
  }

  useImperativeHandle(ref, () => ({
    updateTable,
  }));

  return (
    <Space size={"large"} direction="vertical">
      <StyleTable />
      <DataTable<Infraccion, Infraccion>
        list={props.list}
        title={"Seleccione las infracciones que no se van a imprimir"}
        generateFilters={() => {
          return [];
        }}
        defaultPageSize={100000}
        selectionType="checkbox"
        ref={refTable}
        onRowSelectionChanged={(items) => {
          setIdInfraccionesExcluidas(items.map(e => (e.Id)))
        }}
      >
        <Table.Column<Infraccion>
          width={`5%`}
          title="Id"
          dataIndex={"Id"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Id ? record.Id : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`30%`}
          title="Direccion"
          dataIndex={"Titular.DireccionCompletaTitular"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.DireccionCompletaTitular
                ? record.Titular?.DireccionCompletaTitular
                : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`15%`}
          title="Nombre"
          dataIndex={"Titular.Nombre"}
          //sorter={true}
          sorter={(a, b) => {
            const nombreA = a.Titular?.Nombre || "";
            const nombreB = b.Titular?.Nombre || "";
            const apellidoA = a.Titular?.Apellido || "";
            const apellidoB = b.Titular?.Apellido || "";

            // Primero compara por nombre
            const nombreCompare = nombreA.localeCompare(nombreB);
            // Si los nombres son iguales, compara por apellido
            if (nombreCompare === 0) {
              return apellidoA.localeCompare(apellidoB);
            }
            return nombreCompare;
          }}
          sortDirections={["ascend", "descend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.Nombre ? record.Titular?.Nombre : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`15%`}
          title="Apellido"
          dataIndex={"Titular.Apellido"}
          //sorter
          sorter={(a, b) => {
            const apellidoA = a.Titular?.Apellido || "";
            const apellidoB = b.Titular?.Apellido || "";
            const nombreA = a.Titular?.Nombre || "";
            const nombreB = b.Titular?.Nombre || "";

            // Primero compara por apellido
            const apellidoCompare = apellidoA.localeCompare(apellidoB);
            // Si los apellidos son iguales, compara por nombre
            if (apellidoCompare === 0) {
              return nombreA.localeCompare(nombreB);
            }
            return apellidoCompare;
          }}
          sortDirections={["ascend", "descend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.Apellido ? record.Titular?.Apellido : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`15%`}
          title="Localidad"
          dataIndex={"Titular.LocalidadTitular"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.LocalidadTitular
                ? record.Titular?.LocalidadTitular
                : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`15%`}
          title="Departamento"
          dataIndex={"Titular.DepartamentoTitular"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.DepartamentoTitular
                ? record.Titular?.DepartamentoTitular
                : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`30%`}
          title="Provincia"
          dataIndex={"Titular.ProvinciaTitular"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.ProvinciaTitular
                ? record.Titular?.ProvinciaTitular
                : "-"}
            </div>
          )}
        />

        <Table.Column<Infraccion>
          width={`25%`}
          title="Codigo Postal"
          dataIndex={"Titular.CodigoPostalTitular"}
          sorter
          sortDirections={["ascend", "descend", "ascend"]}
          render={(val, record) => (
            <div style={{ textAlign: "center" }}>
              {record.Titular?.CodigoPostalTitular
                ? record.Titular?.CodigoPostalTitular
                : "-"}
            </div>
          )}
        />
      </DataTable>

      <Space style={{ float: 'right' }} >
        <Button
          loading={loading}
          type="primary"
          onClick={generateLote}
          icon={<FilePdfOutlined />}
        >
          Generar lote de impresión
        </Button>
      </Space>
    </Space>
  );
});
